import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ReactGA from 'react-ga4';
import appConfig from './config/app.config';
import { currentButton } from './store/sidebar.slice';
import { Security } from '@okta/okta-react';
import { OktaAuth } from '@okta/okta-auth-js';
import { MainApp } from './components/layout/main-app';

ReactGA.initialize(appConfig.GOOGLE_ANALYTICS_MEASUREMENT_ID);
const oktaAuth = new OktaAuth(appConfig.OKTA_CONFIG);

function App() {
  const currentPressedButton = useSelector(currentButton);
  const navigate = useNavigate();

  async function restoreOriginalUri(_oktaAuth: OktaAuth, originalUri: string) {
    navigate(currentPressedButton as string, { replace: true });
  }

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <MainApp />
    </Security>
  );
}

export default App;
